export enum Marital {
  SINGLE = 'single',
  MARRIED = 'married',
  DIVORCED = 'divorced',
  WIDOWED = 'widowed',
  NO_INFORMATION = 'no information'
}
